import { useTranslation } from "react-i18next"
import { useAPIResources, useAuth, useQueryState } from "@/hooks"
import { cityAPI, cityName, getFlagEmoji, setQueryCache } from "@/utils"
import { MultiFilter } from "./MultiFilter"

const filterName = "cts"

export function CityFilter() {
  const { t, i18n } = useTranslation()
  const { company } = useAuth()
  const { data: { data } = {}, isPending } = useAPIResources(cityAPI, {
    where: { company_id: company?.id },
    ...setQueryCache(3600e3),
  })
  const items =
    data?.map((city) => ({
      value: city.id,
      label: `${getFlagEmoji(city.country_code)}\xa0\xa0${cityName(city, i18n.language)}`,
    })) || []

  const [value, setValue] = useQueryState<string[]>(filterName, { multi: true })

  return (
    <MultiFilter
      value={value ?? []}
      setValue={(value) => setValue(value?.length > 0 ? value : undefined)}
      items={items}
      loading={isPending}
      label={t("Filter by City")}
    />
  )
}

CityFilter.filterName = filterName

CityFilter.useValue = () => {
  const [value] = useQueryState<string[]>(filterName, { multi: true })
  return value ?? []
}
